import React from 'react';

import { useLocationContext } from 'state/location';
import { routes } from 'utils/routing';

import { BackArrow } from '.';

const NavigationAwareBackArrow = ({ color }: { color: string }) => {
  const { referrerLocation } = useLocationContext();
  const to = referrerLocation || routes.base;

  return <BackArrow to={to} color={color} />;
};

export default NavigationAwareBackArrow;
